function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pixel-this-clothing-/-icons-/-cart---dark",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(1.000000, 1.062831)"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  stroke: "#363636",
  strokeWidth: 2,
  strokeLinecap: "round",
  points: "14.0313452 3.22195781 12.3348033 9.33553911 4.50299515 9.33553911 2.32063768 4.58954875e-13 2.66453526e-15 4.58954875e-13"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(6.153398, 0.377391)",
  stroke: "#363636",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("line", {
  x1: 2.38489902,
  y1: -1.03284528e-13,
  x2: 2.38489902,
  y2: 4.76979804,
  id: "Path-26"
}), /*#__PURE__*/React.createElement("line", {
  x1: 4.76979804,
  y1: 2.38489902,
  x2: 0,
  y2: 2.38489902,
  id: "Path-26"
})), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#363636",
  cx: 4.59098198,
  cy: 13.2172096,
  r: 1.71995947
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#363636",
  cx: 11.7551097,
  cy: 13.2172096,
  r: 1.71995947
})));

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pixel this clothing / icons / cart - dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.dbd0d8bd.svg";
export { ForwardRef as ReactComponent };